/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

const { hasAcceptablePath } = require('./src/components/common/contextLink');
const {
  availableLanguages,
  COMPONENTS,
} = require('./src/components/common/webSiteLanguages');
const {
  getLocalLanguage,
} = require('./src/providers/globalDataProvider/globalDataProvider.provider');

const { pathname } = window.location;

const isAcceptablePath = hasAcceptablePath(pathname);

if (!isAcceptablePath) {
  const { country, language } = getLocalLanguage();
  if (
    country
    && country !== 'null'
    && country !== 'undefined'
    && country !== undefined
    && language
    && language !== 'null'
    && language !== 'undefined'
    && language !== undefined
  ) {
    const link = (
      availableLanguages.find((c) => c.country === country) || { links: {} }
    ).links.find((config) => config.component === COMPONENTS.HOME);
    const slug = link[`slug_${language}`];
    const newPathname = `${country}/${language}/${slug}/`;
    window.location.pathname = newPathname;
    sessionStorage.setItem('show_country_chooser', false);
  } else {
    sessionStorage.setItem('show_country_chooser', true);
  }
}

const customSource = () => {
  const { referrer } = document;
  if (referrer.search('https?://(.*)google.([^/?]*)') === 0) {
    return 'Google';
  }
  if (referrer.search('https?://(.*)bing.([^/?]*)') === 0) {
    return 'Bing';
  }
  if (referrer.search('https?://(.*)yahoo.([^/?]*)') === 0) {
    return 'Yahoo';
  }
  if (referrer.search('https?://(.*)facebook.([^/?]*)') === 0) {
    return 'Facebook';
  }
  if (referrer.search('https?://(.*)twitter.([^/?]*)') === 0) {
    return 'Twitter';
  }
  return 'Direct';
};

const getParameterByName = (rName, rUrl) => {
  const { referrer } = document;
  const url = rUrl || window.location.href;
  const name = rName.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url) || regex.exec(referrer);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const utmSource = getParameterByName('utm_source');
if (utmSource) {
  const epi = getParameterByName('epi');
  sessionStorage.setItem('utmSource', utmSource);
  sessionStorage.setItem('epi', epi);
} else {
  const customUtmSource = customSource();
  sessionStorage.setItem('utmSource', customUtmSource);
}
const utmMedium = getParameterByName('utm_medium');
if (utmMedium) {
  sessionStorage.setItem('utmMedium', utmMedium);
}

const openSignUp = getParameterByName('sign_up');
sessionStorage.setItem('openSignUp', openSignUp);

// exports.onServiceWorkerUpdateFound = (serviceWorker) => {
//   if (serviceWorker.getRegistrations) {
//     serviceWorker.getRegistrations().then((registrations) => {
//       for (const registration of registrations) {
//         caches.keys().then((names) => {
//           for (const name of names) caches.delete(name);
//         });
//         registration.unregister();
//         // window.location.reload(true);
//       }
//     });
//   }
// };